import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import Button from './Button';
import FilterRange from './FilterRange';
import FilterCircle from './FilterCircle';
import ProductsSelected from './ProductsSelected';
import {toggleTooltip} from '../lib/utils';
import styled from 'styled-components';

const StyledPropertyCard = styled.div`
  width: 98%;
  margin: 1%;
  display: block;
  float: left;
  border-radius: 10px;
  background-color: #333;
  box-shadow: 0 0 20px 5px rgba(0,0,0,0.15);
  min-height: 395px;
  text-align: center;
  padding: 16px;
  position: relative;
  @media (min-width: 1024px) {
    width: 48%;
  }
  @media (min-width: 1440px) {
    width: 31.333%;
  }
  > div {
    &:first-child {
      margin-bottom 8px;
      span {
        color: #BBB;
        font-size: 0.75em;
        letter-spacing: 0.5px;
        padding: 0 28px;
        display: block;
        margin-top: 6px;
        cursor: default;
      }
      button {
        position: absolute;
        padding: 0;
        left: 21px;
        top: 21px;
        > i {
          margin: 0;
          svg {
            stroke: #fff;
          }
        }
      }
      > i {
        position: absolute;
        opacity: 0.4;
        width: 16px;
        height: 16px;
        right: 20px;
        top: 21px;
        svg {
          stroke: #fff;
        }
      }
    }
    &:nth-child(2){
      text-align: center;
      width: 100%;
      height: 300px;
    }
  }
  > button {
    margin: auto;
    width: auto;
  }
`;

export default function PropertyCard (props) {
  const {data, apply, removeProp, toggle, setFilter} = props;
  const {key, value, minTotal, maxTotal, label, type, unit, max} = data || {};
  const fix = key === "RefractiveIndex";
  const minCheck = fix && value && value[0] > 1000 ? value[0]/1000 : value ? value[0] : 0;
  const maxCheck = fix && value && value[1] > 1000 ? value[1]/1000 : value ? value[1] : 0;

  return (
    <StyledPropertyCard props={props}>
      <div>
        <Button small dark icon="remove" onClick={type ? () => {setFilter(data); removeProp(key);} : toggle}/>
        {label &&
          <span
            onMouseOver={(e) => toggleTooltip(e, {label})}
            onMouseOut={(e) => toggleTooltip()}
          >{label.toUpperCase()} {!!unit && `(${unit})`}</span>}
        {type && <Icon name={type}/>}
      </div>
      <div>
        {type === "sensory" ? (
          <FilterCircle data={data} setFilter={setFilter}/>
        ) : (type === "physical" || type === "other") ? (
          <FilterRange data={data} setFilter={setFilter} fix={fix}/>
        ) : (
          <ProductsSelected cnt={max} apply={apply}/>
        )}
      </div>
      {((type === "sensory" && !!value)
      || (!!value && !!value.length && (minCheck !== minTotal || maxCheck !== maxTotal))) &&
        <Button small transparent label="reset" color="#eee" onClick={() => setFilter(data)}/>
      }
    </StyledPropertyCard>)
}

PropertyCard.propTypes = {
  reset: PropTypes.func,
  removeProp: PropTypes.func,
  setFilter: PropTypes.func,
  apply: PropTypes.func,
  data: PropTypes.object
};
